import { defineComponent } from "@vue/composition-api";
import SummarySectionLayout from "./summary-section-layout.vue";
import { useIdentificationHelpers } from "@Client/@Composables/application-standalone/pages/identifications/useIdentificationHelpers";
export default defineComponent({
  name: "IdentificationsSection",
  components: {
    SummarySectionLayout
  },
  props: {
    hasMissingInformation: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      applicantHasIdentification,
      identificationSummarySubtitle
    } = useIdentificationHelpers();
    return {
      applicantHasIdentification,
      identificationSummarySubtitle
    };
  }
});